import React, { PropsWithChildren, useCallback, useEffect, useRef } from 'react'
import { css, SerializedStyles } from '@emotion/core'

type Props = {
  isOpen: boolean
  onClose: () => void
  customStyle?: SerializedStyles
}

export const Popup = (props: PropsWithChildren<Props>) => {
  const popupRef = useRef<HTMLDivElement | null>(null)

  const onClickOtherComponent = useCallback(
    event => {
      if (popupRef.current?.contains(event.target as Node)) {
        return
      }
      props.onClose()
    },
    [popupRef],
  )

  useEffect(() => {
    return () => document.removeEventListener('click', onClickOtherComponent)
  }, [])

  useEffect(() => {
    // @see react16用 https://zenn.dev/co9xs/articles/react17-event-delegation
    if (props.isOpen) {
      document.addEventListener('click', onClickOtherComponent)
    } else {
      document.removeEventListener('click', onClickOtherComponent)
    }
  }, [props.isOpen])

  return (
    <div
      css={[dropDownStyle, props.customStyle]}
      style={{
        visibility: props.isOpen ? 'visible' : 'hidden',
      }}
      ref={popupRef}
    >
      {props.children}
    </div>
  )
}

const dropDownStyle = css({
  zIndex: 50,
  backgroundColor: '#FFF',
  position: 'absolute',
  boxShadow: '0px 3px 10px #0000003d',
  borderRadius: 5,
})
